
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Toast from '@/utils/toast';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import TextButton from '@/components/shared/suites/TextButton.vue';
import QuantityInput from '@/components/shared/suites/QuantityInput.vue';

const namespace: string = 'orders';

@Component<CheckinQuestionModal>({
	components: {
		StandardModal,
		TextButton,
		QuantityInput
	}
})
export default class CheckinQuestionModal extends Vue {
	@Action('setOrderItemFromMenuItem', { namespace }) private setOrderItemFromMenuItem!: (menuItem: MenuItem) => void;
	@Action('setOrderItemQuantity', { namespace }) private setOrderItemQuantity!: (quantity: number) => void;
	@Action('addToCart', { namespace }) private addToCart!: (specialInstructions: string) => Promise<void>;
	@Prop({ type: Boolean, required: true }) private showModal!: boolean;
	@Prop({ type: Object, required: true }) private checkinQuestion!: CheckinQuestion;

	private quantities: number[] = this.checkinQuestion.mapped_items.map(() => 0);
	private isLoading: boolean = false;

	/**
	 * Increment the quantity for an option
	 *
	 * @param {number} index
	 * @return {void}
	 */
	private incrementQuantity(index: number): void {
		Vue.set(this.quantities, index, this.quantities[index] + 1);
	}

	/**
	 * Decrement the quantity for an option
	 *
	 * @param {number} index
	 * @return {void}
	 */
	private decrementQuantity(index: number): void {
		if (this.quantities[index] > 0) {
			Vue.set(this.quantities, index, this.quantities[index] - 1);
		}
	}

	/**
	 * Add items to cart based on selected quantities and close modal
	 *
	 * @return {Promise<void>}
	 */
	private async handleContinue(): Promise<void> {
		if (!this.quantities.some(qty => qty > 0)) {
			this.$emit('close');
			return;
		}

		this.isLoading = true;
		try {
			for (let i = 0; i < this.checkinQuestion.mapped_items.length; i++) {
				const mappedItem = this.checkinQuestion.mapped_items[i];
				if (this.quantities[i] > 0 && mappedItem.menu_item) {
					this.setOrderItemFromMenuItem(mappedItem.menu_item);
					this.setOrderItemQuantity(this.quantities[i]);
					await this.addToCart('');
				}
			}
		}
		catch (errorMessage) {
			Toast.error(this.$t('orders.item_viewer.error_adding_to_order', { errorMessage }));
		}
		finally {
			this.isLoading = false;
			this.$emit('close');
		}
	}
}
